import React, { ReactElement, useEffect, useState } from 'react';
import {
  Loader, Table, Tbody, Td, Text, Th, Thead, Tr,
} from 'idsk-react-components';
import './sprievodnyDokumentListTable.scss';
import { useResponsiveContext } from 'slovlex-idsk-react-components';
import Uuid from '../../../../model/Uuid';
import DownloadSprievodnyDokumentButton from '../../component/DownloadSprievodnyDokumentButton';
import useSprievodnyDokumentList from '../hook/useSprievodnyDokumentList';
import { useClient } from '../../../../context/ClientStatusContext';
import {
  downloadSprievodnyDokumentByUuid,
} from '../../../../client/external/evidencnaaplikacia/sprievodnyDokumentDownloadClient';
import downloadFile from '../../../../function/downloadFile';
import SprievodnyDokumentDetailRow from '../../SprievodnyDokumentUpdateList/component/SprievodnyDokumentDetailRow';
import getFileSize from '../../../../function/getFileSize';

interface Props {
  legMaterialUuid: Uuid;
  selectedStadiumUuid: Uuid;
  setDocumentsExists: (documentsExists: boolean) => void;
}

const SprievodnyDokumentListTable = ({
  legMaterialUuid,
  selectedStadiumUuid,
  setDocumentsExists,
}: Props): ReactElement => {
  const [downloadingDokumentUuid, setDownloadingDokumentUuid] = useState<string>();
  const {
    sprievodnyDokumentList,
    sprievodnyDokumentStatus,
  } = useSprievodnyDokumentList(legMaterialUuid, selectedStadiumUuid);

  useEffect(() => {
    if (sprievodnyDokumentList && sprievodnyDokumentList.length > 0) {
      setDocumentsExists(true);
    } else {
      setDocumentsExists(false);
    }
  }, [setDocumentsExists, sprievodnyDokumentList]);

  const {
    wrapClient: downloadSprievodnyDokumentClient,
    status: downloadSprievodnyDokumentStatus,
  } = useClient(downloadSprievodnyDokumentByUuid);
  const downloadDokument = async (dokumentUuid: Uuid, filename: string): Promise<void> => {
    setDownloadingDokumentUuid(dokumentUuid);
    const { data } = await downloadSprievodnyDokumentClient(dokumentUuid);
    setDownloadingDokumentUuid(undefined);
    if (data) {
      downloadFile(filename, data);
    }
  };

  const { isSmallScreen } = useResponsiveContext();

  if (sprievodnyDokumentList?.length === 0) {
    return <Text type="p" size="l" className="text-center">Nenašli sa žiadne záznamy.</Text>;
  }

  if (isSmallScreen) {
    return (
      <div>
        {sprievodnyDokumentList?.map((dokument, index) => (
          <SprievodnyDokumentDetailRow
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            nazov={dokument.nazov}
            typDokumentu={dokument.typ?.nazov}
            velkost={dokument.velkost}
            povinne={false}
            actions={(
              <DownloadSprievodnyDokumentButton
                sprievodnyDokumentUuid={dokument.uuid}
                filename={dokument.nazov}
                downloadDokument={downloadDokument}
                downloadDokumentStatus={downloadingDokumentUuid === dokument.uuid
                  ? downloadSprievodnyDokumentStatus
                  : undefined}
              />
              )}
          />
        ))}
      </div>
    );
  }

  return (
    <Loader loading={sprievodnyDokumentStatus.loading}>
      <div className="sprievodny-dokument-list__table">
        <Table>
          <Thead>
            <Tr>
              <Th width="40%">
                Názov
              </Th>
              <Th width="40%">
                Typ dokumentu
              </Th>
              <Th width="10%">Veľkosť</Th>
              <Th width="10%" />
            </Tr>
          </Thead>
          <Tbody>
            {sprievodnyDokumentList?.map((dokument) => (
              <Tr key={dokument.uuid}>
                <Td>{dokument.nazov}</Td>
                <Td>{dokument.typ?.nazov}</Td>
                <Td>
                  {getFileSize(dokument.velkost)}
                </Td>
                <Td>
                  <DownloadSprievodnyDokumentButton
                    sprievodnyDokumentUuid={dokument.uuid}
                    filename={dokument.nazov}
                    downloadDokument={downloadDokument}
                    downloadDokumentStatus={downloadingDokumentUuid === dokument.uuid
                      ? downloadSprievodnyDokumentStatus
                      : undefined}
                  />
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>
    </Loader>
  );
};

export default SprievodnyDokumentListTable;
